import(/* webpackMode: "eager" */ "/home/kehutanan-web/kehutanan-web/src/app/error.tsx");
